/// <amd-module name="Wit/UI/Client" />
export type WorkItemId = number;

/**
 * Named string type for WIQL.
 */
export type Wiql = string;

export function isWorkItemIdType(input: any): boolean {
    return typeof input === "number";
}
